
import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    noPadding?: boolean;
    hover?: boolean;
    glass?: boolean;
}

const Card: React.FC<CardProps> = ({
    children,
    className = '',
    noPadding = false,
    hover = false,
    glass = false
}) => {
    const padding = noPadding ? '' : 'p-6 md:p-8';
    const hoverEffect = hover ? 'transition-all duration-300 hover:shadow-premium hover:-translate-y-1' : '';
    const bg = glass ? 'glass' : 'bg-white';

    return (
        <div className={`${bg} rounded-2xl shadow-soft border border-gray-100 ${padding} ${hoverEffect} ${className}`}>
            {children}
        </div>
    );
};

export default Card;
